"use strict";
exports.__esModule = true;
var TypedTimer = (function () {
    function TypedTimer() {
        this.timeoutId = null;
        this.intervalId = null;
        this.immediateId = null;
        this.animationId = null;
        this.animationStep = this.animationStep.bind(this);
    }
    TypedTimer.prototype.setTimeout = function (callback, timeout) {
        this.clear();
        this.timeoutId = setTimeout(callback, timeout);
    };
    TypedTimer.prototype.setInterval = function (callback, interval) {
        this.clear();
        this.intervalId = setInterval(callback, interval);
    };
    TypedTimer.prototype.setImmediate = function (callback) {
        this.clear();
        this.immediateId = setImmediate(callback);
    };
    TypedTimer.prototype.setAnimation = function (callback) {
        this.clear();
        this.animationCallback = callback;
        this.animationId = requestAnimationFrame(this.animationStep);
    };
    TypedTimer.prototype.animationStep = function (timeStamp) {
        this.animationCallback(timeStamp);
        this.animationId = requestAnimationFrame(this.animationStep);
    };
    TypedTimer.prototype.isActive = function () {
        return this.timeoutId !== null || this.intervalId !== null || this.immediateId !== null || this.animationId !== null;
    };
    TypedTimer.prototype.clear = function () {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
        if (this.immediateId) {
            clearImmediate(this.immediateId);
            this.immediateId = null;
        }
        if (this.animationId) {
            cancelAnimationFrame(this.animationId);
            this.animationId = null;
        }
    };
    return TypedTimer;
}());
exports["default"] = TypedTimer;
//# sourceMappingURL=index.js.map